import { PickerColumnItem } from '@components/picker-view/src';

export const defaultRenderLabel = (item: PickerColumnItem) => item.label
